import * as Yup from 'yup';

import { companySizeOptions as defaultCompanySizeOptions } from '../../../defaultFilters';

export const useCompanySizeFilter = ({ setFilters }) => {
  const companySizeOptions = defaultCompanySizeOptions;

  const formSchema = Yup.object().shape({
    currentCompanySizes: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      }),
    ),
  });

  const onSubmit = ({ currentCompanySizes }) => {
    setFilters({ currentCompanySizes });
  };

  return {
    formSchema,
    onSubmit,
    companySizeOptions,
  };
};
